import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useCurrency } from "@/context/CurrencyContext";
import { StatusBadge } from "@/components/StatusBadge";
import { format } from "date-fns";

export default function Invoices() {
  const [invoices, setInvoices] = useState(null);
  const { fmt } = useCurrency();
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/invoices").then(({ data }) => setInvoices(data)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  return (
    <div className="space-y-6" data-testid="invoices-page">
      <div>
        <h1 className="font-heading text-3xl font-bold">Invoices</h1>
        <p className="text-sm text-muted-foreground">Bills generated from bookings, with payments.</p>
      </div>

      <div className="overflow-x-auto border border-border bg-card">
        <table className="w-full min-w-[800px] text-sm">
          <thead>
            <tr className="border-b border-border text-left text-xs uppercase tracking-wider text-muted-foreground">
              <th className="p-3 font-medium">Invoice</th>
              <th className="p-3 font-medium">Guest</th>
              <th className="p-3 font-medium">Issued</th>
              <th className="p-3 text-right font-medium">Total</th>
              <th className="p-3 text-right font-medium">Paid</th>
              <th className="p-3 text-right font-medium">Balance</th>
              <th className="p-3 font-medium">Status</th>
            </tr>
          </thead>
          <tbody>
            {(invoices || []).map((inv) => (
              <tr key={inv.id} onClick={() => navigate(`/invoices/${inv.id}`)}
                className="cursor-pointer border-b border-border last:border-0 transition-colors hover:bg-secondary/40"
                data-testid={`invoice-row-${inv.id}`}>
                <td className="p-3 font-heading font-bold">{inv.number}</td>
                <td className="p-3">{inv.guest_name}</td>
                <td className="p-3 text-muted-foreground">{format(new Date(inv.issued_at), "dd MMM yyyy")}</td>
                <td className="p-3 text-right font-medium">{fmt(inv.total)}</td>
                <td className="p-3 text-right text-status-confirmed">{fmt(inv.amount_paid)}</td>
                <td className="p-3 text-right">{fmt(inv.total - inv.amount_paid)}</td>
                <td className="p-3"><StatusBadge status={inv.status} testId={`invoice-status-${inv.id}`} /></td>
              </tr>
            ))}
          </tbody>
        </table>
        {invoices && invoices.length === 0 && (
          <div className="p-10 text-center text-sm text-muted-foreground" data-testid="invoices-empty">
            No invoices yet — create one from a booking.
          </div>
        )}
      </div>
    </div>
  );
}
